import React from 'react';
import { FC } from 'react';
import Link from 'next/link';

type Props = {
  redirectHref: string;
  setIsGoogleConnect: React.Dispatch<React.SetStateAction<boolean>>;
};

const GoogleInstructions: FC<Props> = ({
  redirectHref,
  setIsGoogleConnect,
}) => {
  return (
    <div className="flex flex-col items-center gap-[5px] px-3">
      <div className="flex flex-row items-center justify-center gap-3">
        <p className="text-left lg:w-5/15 w-1/2 text-sm">
          Your calendar/contacts provider &#40;Google&#41; will now ask you
          whether you want to allow access for Confirmed.
        </p>
        <img
          src="/GooglePermissions.png"
          className="rounded-xl lg:w-7/12 w-1/2"
        />
      </div>
      <p className="text-left font-bold">
        We recommend allowing all requested permissions.
      </p>
      <div className="flex flex-row justify-center items-center gap-3 w-3/4">
        <Link
          href={`/api/auth/login?provider=google-oauth2&redirect-url=${redirectHref}`}
        >
          <button className="bg-white rounded-md drop-shadow-xl hover:cursor-pointer text-black px-3 py-1">
            Continue
          </button>
        </Link>
        <button
          className="rounded-md drop-shadow-xl hover:cursor-pointer text-black px-3 py-1 bg-gray-400"
          onClick={() => setIsGoogleConnect(false)}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default GoogleInstructions;
